import { alignToJustifyContent } from "@client/content/lib/settings";
import { combinedClassNameSelector } from "@client/content/selectors";
import {
  combinedSettingsSelector,
  createShallowEqualSelector,
  getSettingValueSelector,
  type SettingsPropsParametricSelector,
  TargetSelector
} from "@client/selectors";
import classNames from "classnames";
import * as React from "react";
import { createSelector } from "reselect";

export const makeClassNameSelector = () => {
  const classNameSelector = combinedClassNameSelector(TargetSelector.Entity, ["listIconStyle", "listIconColored"]);
  const isInlineSelector = getSettingValueSelector(TargetSelector.Entity, "listInline");

  return createSelector([classNameSelector, isInlineSelector], (className, isInline): string =>
    classNames("wsc_content_lists", className, { inline: isInline })
  );
};

export const makeContainerStyleSelector = (): SettingsPropsParametricSelector => {
  const settingsSelector = combinedSettingsSelector<{
    contentHorizontalAlign: string;
    horizontalGap: number;
    columns: number;
    isInline: boolean;
    verticalGap: number;
  }>(TargetSelector.Entity, [
    { name: "listInline", prop: "isInline" },
    "contentHorizontalAlign",
    "horizontalGap",
    "columns",
    { name: "spacing", prop: "verticalGap" }
  ]);

  return createShallowEqualSelector(
    [settingsSelector],
    (settings): React.CSSProperties =>
      settings.isInline
        ? {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: alignToJustifyContent(settings.contentHorizontalAlign),
            rowGap: settings.verticalGap,
            columnGap: settings.horizontalGap
          }
        : {
            display: "grid",
            gridTemplateColumns: `repeat(${settings.columns}, 1fr)`,
            rowGap: settings.verticalGap
          }
  );
};
